import { useQuery } from "@tanstack/react-query";
import { extractPaginatedCollection } from "../../utils/apiResponse";

async function getDistributions({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
  signal,
}) {
  const url =
    `/distributions?language=${encodeURIComponent(language)}` +
    `&page=${pageIndex}&size=${pageSize}`;

  const res = await callApiWithWorker(url, { method: "GET", signal });
  return extractPaginatedCollection(res);
}

export function useGetDistributions({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
}) {
  return useQuery({
    queryKey: ["distributions", language, pageIndex, pageSize],
    queryFn: ({ signal }) =>
      getDistributions({
        callApiWithWorker,
        language,
        pageIndex,
        pageSize,
        signal,
      }),
    enabled:
      Boolean(callApiWithWorker) &&
      Boolean(language) &&
      Number.isInteger(pageIndex) &&
      Number.isInteger(pageSize),
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
}
